import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import formatDate from "../../utils";

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(
          "http://fundoramaa.co.in//api/v1/users/profile"
        );
        if (response.data && Array.isArray(response.data.data)) {
          setUsers(response.data.data);
          console.log(response.data.data);
        } else {
          console.error("Unexpected response format:", response.data);
          setUsers([]);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  return (
    <>
      <Header />

      <section className="pb-7 mt-4 mb-3">
        <div className="container">
          {loading ? (
            <div class="spinner-border" role="status"></div>
          ) : (
            <>
              <table class="table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">User Details</th>
                    <th scope="col">Date / Time</th>
                  </tr>
                </thead>
                <tbody>
                  {users
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
                    )
                    .map((user, index) => (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td>
                          ID : {user._id} <br />
                          Name : {user.name} <br />
                          Mobile No : {user.mobile} <br />
                          Occupation : {user.occupation[0]} <br />
                          Participated In : {user.participatedIn[0]} <br />
                          Referral Code : {user.referralCode} <br />
                          Role :{" "}
                          {user.role.includes("content_producer") &&
                          user.role.includes("investor")
                            ? "Content Producer / Investor"
                            : user.role === "content_producer"
                            ? "Content Producer"
                            : user.role === "investor"
                            ? "Investor"
                            : "Unknown Role"}
                        </td>
                        <td className="text-uppercase">
                          {formatDate(user.createdAt)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
        </div>
      </section>
    </>
  );
}

export default Users;
